/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'authoring-common'
], function(
	AuthoringCommon
) {

	let SchematicEditor = AuthoringCommon.SchematicEditor;
	let dialogWrapper = AuthoringCommon.DialogWrapper;

	return class SchematicEditorUI {

		static openSchematicEditor( metadata ) {
			if (!metadata) {
				return;
			}

			let resolve, reject, data;
			let promise = new Promise( function( _resolve, _reject ) {
				resolve = _resolve;
				reject = _reject;
			});


			let _okCallbackFn = function( _editorResponse ) {
				// save the data which we're going to return
				data = _editorResponse;
			};

			let _onCloseDialog = function() {
				// if when we close the dialog we have data
				// the data is to be resolved
				return data ? resolve(data ) : reject();
			};

			let _onOpenDialog = function( _schematicEditorRef ) {
				if ( _schematicEditorRef )
					_schematicEditorRef.openDialog();
			};
			dialogWrapper.show(SchematicEditor,
				{
					definition: metadata,
					okCallbackFn: _okCallbackFn,
					onCloseDialog: _onCloseDialog,
					ref: _onOpenDialog
				});

			return promise;
		}
	};
});
